import styled from 'styled-components';

export const Container = styled.div`
    background-color: #fff;
    position: fixed;
    width: 100vw;
    min-height: 100vh;
    max-height: 100vh;
    height: 100%;
    margin: 0;
    margin-left: ${(props) => (props.active ? '0' : '-200vw')};
    transition: var(--transition);
    z-index: 15;
    top: 0;
    left: 0;
    overflow: auto;

    ::-webkit-scrollbar {
        border-radius: 10px;
        width: 0.4rem;
        height: 0.4rem;
    }

    ::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background: #bbb;
    }

    ::-webkit-scrollbar-thumb:hover {
        border-radius: 10px;
        background: #aaa;
    }

    > header {
        padding: 1rem 1rem 1rem 1rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #333;
        position: sticky;
        top: 0;
        background-color: #fff;
        z-index: 5;

        > h2 {
            font-size: 18px;
            color: var(--color-primary);
        }

        > button {
            color: var(--color-primary);
            padding: 0;
            margin: 0;
        }
    }

    > main {
        overflow: auto;
        max-width: 100%;
        padding-bottom: 80px;

        ::-webkit-scrollbar {
            border-radius: 10px;
            width: 0.4rem;
            height: 0.4rem;
        }

        ::-webkit-scrollbar-thumb {
            border-radius: 10px;
            background: #bbb;
        }

        ::-webkit-scrollbar-thumb:hover {
            border-radius: 10px;
            background: #aaa;
        }
    }

    > footer {
        position: fixed;
        transition: var(--transition);
        margin-left: ${(props) => (props.active ? '0' : '-200vw')};

        z-index: 8;
        background-color: #fff;
        padding: 1rem 1rem 1rem 1rem;
        width: 100%;
        bottom: 0;
        left: 0;
        border-top: 1px solid #000;
        display: flex;
        height: 80px;
        max-width: 600px;

        > * {
            flex: 1;
            &:first-child {
                margin-right: 0.5rem;
            }

            &:last-child {
                margin-left: 0.5rem;
            }
        }
    }

    @media screen and (min-width: 768px) {
        width: 600px;
        margin-left: ${(props) => (props.active ? '0' : '-600px')};
    }
`;

export const Item = styled.div`
    display: flex;
    padding: 1rem;
    border-bottom: 1px solid #ddd;
`;
